// extracted by mini-css-extract-plugin
export default {"hideTooltip":"R9-z","fadeIn":"S9-z","delay":"T9-z","recommendedSizeTooltip":"U9-z"};